<template>
    <div class='container_wrap'>
        <div class="sticky">
            <!-- <div class="title-box">
                <div class="status-box">已签约</div>
                <div class="title">
                    {{projectObj.name}}
                </div>
            </div>
            <div class="project-info flc2">
                <div class="project-info-title">项目类型：</div>
                <div class="project-info-content">
                    {{projectObj.type}}
                </div>
            </div>
            <div class="project-info flc2">
                <div class="project-info-title">成交金额：</div>
                <div class="project-info-content">
                    {{projectObj.money}}元
                </div>
            </div>
            <div class="project-tips flc2">
                <img src="@/assets/images/archives/dossier/team_icon.png" alt="">
                项目团队
            </div>
            <div class="people-box">
                <div class="people-item" v-for="(item,index ) in jobList" :key="index">
                    <div class="people-item-job">{{item.jobname}}：</div>
                    <div class="people-item-uname">{{item.uname}}</div>
                </div>
            </div>
            <div class="center-btn-list" v-if="false">
                <div class="btn-item" v-for="(item,index) in btnList" :key="index">
                    {{item.title}}
                </div>
            </div> -->
            <!-- <div class="line-box"></div> -->
            <!-- <navbar :index="2"></navbar> -->
            <pronav :projectId="nProject"></pronav>
            <!-- <topnav :topnavList="topnavList" @changeIndex="topnacChange" :currentIndex="currentIndex"></topnav> -->
        </div>
        <!-- <transition name="navContent" mode="out-in">
            <div style="z-index: 1;" v-if="currentIndex == 0" key="report">
                <div class="dossier-img" v-if="this.arrChange.length < 1">
                    <img src="@/assets/images/archives/dossier/contract_not.png" />
                    <div class="noMore">暂无信息</div>
                </div>
            </div>
            <div style="z-index: 1;" v-else-if="currentIndex == 1" key="pronav">
                <div class="dossier-img" v-if="this.arrChange.length < 1">
                    <img src="@/assets/images/archives/dossier/contract_not.png" />
                    <div class="noMore">暂无信息</div>
                </div>
            </div>
            <div style="z-index: 1;" key="pronav2">
                <pronav :projectId="nProject"></pronav>
            </div>
        </transition> -->
        <div class="empty" v-show="bShowBottom"></div>
        <div class="bottom-box" v-show="bShowBottom">
            <div class="door-survey flc">上门勘察</div>
        </div>
    </div>
</template>
<script>
    import navbar from '../dossier/components/nav_bar/index'
    import topnav from './components/topnav'
    import report from './components/report'
    import pronav from '@/page/archives/dossier/components/prog_taber/index'

    import oInfo from '@/js/archives/survey/index.js'
    // auther wcp
    export default {
        name: "designInfo",

        // 组件注册
        components: {
            report,
            navbar,
            topnav,
            pronav
        },
        data() {
            return {
                jobList: [{
                    jobname: '签单手',
                    uname: '刘玉婷'
                }, {
                    jobname: '签单手',
                    uname: '刘玉婷'
                }, {
                    jobname: '签单手',
                    uname: '刘玉婷'
                }, {
                    jobname: '签单手',
                    uname: '刘玉婷'
                }, {
                    jobname: '签单手',
                    uname: '刘玉婷'
                }, ],
                bShowBottom: false,
                currentIndex: 0, //当前选中
                projectObj: {
                    name: '苏州市吴中区星港街263号加城湖滨公寓5栋3单元1506室',
                    type: '空调新风壁挂炉(地暖)',
                    money: '8100000',
                    uname: '刘玉婷'
                },
                btnList: [{
                    title: '发货提醒',
                }, {
                    title: '转派'
                }],
                topnavList: [{
                        name: '勘察报告',
                    }, {
                        name: '项目方案书'
                    },
                    {
                        name: '方案设计'
                    }
                ],
                arrChange: [],
                nProject: '',
            };
        },
        methods: {
            topnacChange(index) {
                this.currentIndex = index;
            },
            getToData() {
                this.$store.commit("loadSwitch", true);
                oInfo.designTags({
                    project_id: this.nProject,
                }).then(res => {
                    this.$store.commit("loadSwitch", false);
                    console.log(res)
                    this.arrChange = res.data.data.result.list
                })
            },
        },
        //生命周期 - 创建完成
        created() {
            this.nProject = this.$route.query.project_id
        },
    }
</script>
<style lang='scss' scoped>
    .flc {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .flc2 {
        display: flex;
        align-items: center;
    }

    .positionc {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
    }

    .dossier-img {
        text-align: center;

        /* margin: 0 auto; */
        img {
            width: 400px;
            height: 422px;
        }

        .noMore {
            font-size: 28px;
            font-weight: 400;
            color: #999999;
            text-align: center;
        }
    }


    .container_wrap {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #fff;

        .sticky {
            padding-top: 20px;
            position: sticky;
            top: 80px;
            /* padding: 32px 34px 0; */
            z-index: 10;
            background-color: #fff;
        }

        .title-box {
            position: relative;

            .title {
                width: 100%;
                text-indent: 3em;
                font-size: 36px;
                font-weight: 600;
                color: #333333;
                line-height: 50px;
            }

            .status-box {
                position: absolute;
                left: 0;
                top: 0px;
                background: #24AE71;
                border-radius: 106px 106px 106px 106px;
                border: 2px solid #24AE71;
                font-size: 24px;
                font-weight: 400;
                color: #FFFFFF;
                padding: 3px 12px;
            }
        }

        .project-info {
            display: flex;
            margin-top: 20px;

            .project-info-title {
                width: 120px;
                font-size: 24px;
                font-weight: 400;
                color: #A3A3A3;
            }

            .project-info-content {
                flex: 1;
                font-size: 24px;
                font-weight: 400;
                color: #3D3C4F;
            }
        }

        .project-tips {
            font-size: 24px;
            margin: 32px 0 32px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;

            img {
                width: 30px;
                height: 30px;
                margin-right: 20px;
            }
        }

        .people-box {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            row-gap: 20px;

            .people-item {
                display: flex;
                height: 28px;

                .people-item-job {
                    font-size: 24px;
                    font-weight: 400;
                    color: #A3A3A3;
                    line-height: 28px;
                }

                .people-item-uname {
                    font-size: 24px;
                    font-weight: 400;
                    color: #3D3C4F;
                    line-height: 28px;
                }
            }
        }

        .center-btn-list {
            margin: 48px 0 0;

            .btn-item {
                width: 150px;
                height: 64px;
                margin-right: 28px;
                display: inline-block;
                border-radius: 16px 16px 16px 16px;
                opacity: 1;
                border: 2px solid #0D53FC;
                font-size: 24px;
                font-weight: 400;
                color: #0D53FC;
                line-height: 66px;
                text-align: center;
            }
        }

        .line-box {
            width: 100%;
            height: 2px;
            border: 2px solid #F5F5F5;
            margin: 48px 0;
        }

        .empty {
            width: 100%;
            height: 150px;
        }

        .bottom-box {
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100vw;
            z-index: 10;
            padding: 24px 32px env(safe-area-inset-bottom) 0;
            display: flex;
            justify-content: flex-end;
            background: #FFFFFF;
            box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.0300);
            border-radius: 0px 0px 0px 0px;

            .door-survey {
                width: 160px;
                height: 64px;
                background: #0D53FC;
                border-radius: 16px 16px 16px 16px;
                opacity: 1;
                font-size: 24px;
                font-weight: 500;
                color: #FFFFFF;
            }
        }
    }

    .navContent-enter-active,
    .navContent-leave-active {
        transition: all 0.4s;
    }

    .navContent-enter {
        opacity: 0;
        transform: translateX(30px);
    }

    .navContent-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }
</style>
